import { FeatureHubGuard } from "@/featureFlags";
import { MeteomaticsLogo } from "@/meteomatics-logo";
import { ProfileWindowOverlay } from "@/overlay/overlays/profile/ProfileWindowOverlay";
import { pageMarketplace, pageProfiles, startsWithExtraPath } from "@/route";
import { classNames } from "@/utility/jsx";
import { t } from "@lingui/core/macro";
import { Tabset } from "@mm/metx-design-system";
import type { ReactNode } from "react";
import { useHistory, useLocation } from "react-router-dom";
import logo from "../logo-ncm.png";
import "./profile.scss";

export type ProfileAreaTab = "profiles" | "marketplace";

type ProfileAreaLayoutProps = {
  activeTab: ProfileAreaTab;
  showCustomLogo?: boolean;
  children?: ReactNode;
};

export function ProfileAreaLayout({ activeTab, showCustomLogo, children }: ProfileAreaLayoutProps) {
  const history = useHistory();
  const location = useLocation();
  const routePrefix = startsWithExtraPath(location.pathname);

  const handleTabChange = (value: string) => {
    if (value === "profiles") {
      history.push(`${routePrefix}${pageProfiles.asString()}`);
      return;
    }
    if (value === "marketplace") {
      history.push(`${routePrefix}${pageMarketplace.asString()}`);
    }
  };

  return (
    <>
      <div className="page page--profile-area cover-window overlay">
        <div className={classNames("box-section", "background-img", showCustomLogo && "custom-logo-background")}>
          <div className="intro-watermark">
            {showCustomLogo ? <h1>Welcome to meteoKSA</h1> : <h1>Welcome to MetX</h1>}
          </div>
          {showCustomLogo ? <img height="80" src={logo} alt="logo ncm" /> : <MeteomaticsLogo />}
        </div>
        <FeatureHubGuard flag="marketplace">
          <div className="profile-area-tabs">
            <div className="profile-area-tabs__inner">
              <Tabset
                className="profile-area-tabs__tabset"
                size="lg"
                activeValue={activeTab}
                items={[
                  {
                    icon: <span className="material-symbols-outlined">home</span>,
                    label: t({
                      id: "profiles.tab.dashboards",
                      message: "Dashboards",
                    }),
                    value: "profiles",
                  },
                  {
                    icon: <span className="material-symbols-outlined">storefront</span>,
                    label: t({
                      id: "profiles.tab.marketplace",
                      message: "Marketplace",
                    }),
                    value: "marketplace",
                  },
                ]}
                onChange={handleTabChange}
              />
            </div>
          </div>
        </FeatureHubGuard>
        <div className="box-section">
          <div className="profile-area-content profile-area-content--page">{children}</div>
        </div>
      </div>
      <ProfileWindowOverlay />
    </>
  );
}
